import { useNavigate } from 'react-router-dom';
import { DestinationStrings } from '../../strings';
import { IntroductionWidget } from '../../../shared/components/IntroductionWidget/IntroductionWidget';
import { IntroductionWidgetIcon } from '../../../shared/components/IntroductionWidget/IntroductionWidgetIcon';
import { useAnalyticsTracker } from '../../../tracking/hooks/useAnalyticsTracker';
import { DestinationTrackers } from '../../tracking/destination-trackers';

export function DestinationIntro({ dataId = '' }: { dataId?: string }) {
  const { eventTrack } = useAnalyticsTracker();
  const navigate = useNavigate();

  const navigateToDestinationCreate = () => {
    eventTrack({
      action:
        DestinationTrackers.DESTINATION_TRACKER_EMPTY_DESTINATIONS_CREATE_FIRST_DESTINATION_CLICK
    });

    navigate('/destination/create');
  };

  return (
    <IntroductionWidget
      dataId={dataId}
      entity='Destinations'
      title={DestinationStrings.introTitle}
      description={DestinationStrings.introDescription}
      illustration={<IntroductionWidgetIcon iconName='destinations' dataId='db' />}
      buttonProps={{
        size: 'lg',
        children: 'Create Your First Destination',
        onClick: navigateToDestinationCreate
      }}
    />
  );
}
